const baseUrl = ''
 //const baseUrl = 'http://localhost:6798';
export {baseUrl};


const sendOtpApi = `${baseUrl}/api/send-otp`
export {sendOtpApi};


const verifyOtpApi = `${baseUrl}/api/verify-otp`
export {verifyOtpApi};

const subscribeUserApi = `${baseUrl}/api/subscribe-user`
export {subscribeUserApi};

const checkUserApi = `${baseUrl}/api/check-user`
export {checkUserApi};

const chargeApi = `${baseUrl}/payment`
export {chargeApi};


const deactivateApi = `${baseUrl}/user/deactivate-user`
export {deactivateApi}


const loginApi = `${baseUrl}/user/login`
export {loginApi}

const getCategoriesApi = (language) => `${baseUrl}/api/get-categories?language=${language}`
export {getCategoriesApi};

const getRecipesApi = (id, language) => `${baseUrl}/api/get-recipes/${id}?language=${language}`
export {getRecipesApi};


const getRecipeDetailApi = (id, language) => `${baseUrl}/api/get-recipe/${id}?language=${language}`
export {getRecipeDetailApi};



const addRecipeApi = `${baseUrl}/user/add-recipe`
export {addRecipeApi}